export class SlotGroupServices {
  constructor($axios) {
    this.$axios = $axios;
  }

  async getSlotGroupList(payload) {
    const { data } = await this.$axios.post(`/slotgroup/list`, payload);
    return data;
  }

  async getSlotGroupDetail(id) {
    const { data } = await this.$axios.get(`/slotgroup/${id}`);
    return data;
  }

  async saveSlotGroupDetail(payload, id) {
    const { data } = await this.$axios.post(`/slotgroup/${id}`, payload);
    return data;
  }

  async getExtraDateList(payload, id) {
    const { data } = await this.$axios.post(
      `/slotgroup/${id}/extraDateList`,
      payload
    );
    return data;
  }

  async saveExtraDate(payload) {
    const { data } = await this.$axios.post(`/slotgroup/extraDate`, payload);
    return data;
  }

  async changeStatus(payload) {
    const { data } = await this.$axios.post(`/slotgroup/extraDate/ChangeStatus`, payload);
    return data;
  }
}
